/* osyn-plateforme-achat.js — barre d'achat flottante (snippet osyn-plateforme-achat) : pages plateformes, catalogue ----
 * Affichée une fois le bouton de la section (data-achat-ancre) dépassé vers le haut, sur téléphone comme sur ordinateur,
 * masquée tant que le pied de page est à l'écran. Masquée = classe retirée (CSS : hors écran, visibility hidden) + inert.
 * Comme la barre de l'accueil (osyn-meet.js) : un élément de la page qui prend le focus au clavier sous la barre est
 * remonté juste au-dessus (WCAG 2.4.11), seulement si la barre est réellement rendue.
 * Le bouton soumet le formulaire produit natif de la barre : Concept ajoute au panier, ouvre le tiroir et affiche une
 * erreur éventuelle dans la barre ; elle s'efface après 6 s.
 * Éditeur de thème : section de la barre sélectionnée = barre affichée pour la régler.
 * -------------------------------------------------------------------------- */
(function () {
  'use strict';
  if (window.OsynPfAchat) return;   // l'éditeur ré-exécute les scripts d'une section rechargée
  window.OsynPfAchat = true;

  var ERREUR_MS = 6000;
  var ECART = 8;

  function focusVisible(el) {
    try { return el.matches(':focus-visible'); } catch (e) { return true; }
  }

  function init(barre) {
    if (barre._osynAchat) return;
    barre._osynAchat = true;

    var section = barre.closest('.shopify-section') || document;
    var ancre = section.querySelector('[data-achat-ancre]');
    var erreur = barre.querySelector('.product-form__error-message');
    var controleur = new AbortController();
    var o = { signal: controleur.signal };
    var depasse = false, epingle = false, minuteur = null;
    var bloqueurs = new Set();

    function rendre() {
      var visible = epingle || (depasse && bloqueurs.size === 0);
      barre.classList.toggle('is-shown', visible);
      barre.inert = !visible;
    }

    /* Racine prolongée vers le bas : « au-dessus de l'écran » devient un état à part entière, donc un saut
       par-dessus le bouton (lancer rapide, lien d'ancre) change aussi l'état. */
    var ioAncre = new IntersectionObserver(function (entrees) {
      var e = entrees[entrees.length - 1];
      depasse = !e.isIntersecting && e.boundingClientRect.bottom <= 0;
      rendre();
    }, { rootMargin: '0px 0px 1000000px 0px' });
    var ioBloqueurs = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (e) {
        if (e.isIntersecting) bloqueurs.add(e.target);
        else bloqueurs.delete(e.target);
      });
      rendre();
    });
    if (ancre) ioAncre.observe(ancre);
    document.querySelectorAll('.footer-group, .shopify-section-group-footer-group').forEach(function (el) { ioBloqueurs.observe(el); });

    document.addEventListener('focusin', function (e) {
      if (!barre.classList.contains('is-shown') || !barre.getClientRects().length) return;
      if (barre.contains(e.target) || !e.target.closest('#MainContent') || !focusVisible(e.target)) return;
      var rect = e.target.getBoundingClientRect();
      var recouvre = rect.bottom - barre.getBoundingClientRect().top;
      /* borné par le haut de l'élément : un élément haut n'est jamais poussé hors de l'écran */
      if (recouvre > 0) window.scrollBy(0, Math.min(recouvre + ECART, Math.max(0, rect.top)));
    }, o);

    document.addEventListener('ajaxProduct:error', function () {
      if (!erreur || erreur.hidden) return;
      clearTimeout(minuteur);
      minuteur = setTimeout(function () { erreur.hidden = true; erreur.textContent = ''; }, ERREUR_MS);
    }, o);

    document.addEventListener('shopify:section:select', function (e) {
      if (e.target === section) { epingle = true; rendre(); }
    }, o);
    document.addEventListener('shopify:section:deselect', function (e) {
      if (e.target === section) { epingle = false; rendre(); }
    }, o);
    document.addEventListener('shopify:section:unload', function (e) {
      if (e.target !== section) return;
      controleur.abort();
      ioAncre.disconnect();
      ioBloqueurs.disconnect();
      clearTimeout(minuteur);
    }, o);

    rendre();
  }

  function demarrer(portee) {
    portee.querySelectorAll('[data-osyn-pf-achat]').forEach(init);
  }

  demarrer(document);
  document.addEventListener('shopify:section:load', function (e) { demarrer(e.target); });
})();
